/**
 * Tarteaucitron services observable.
 *
 * @class
 */
export default class ServicesObservable {
  constructor() {
    /**
     * List of observers indexed by service name.
     *
     * @type {Object}
     * @public
     */
    this.observers = {};
  }

  /**
   * Add service observer.
   *
   * @param {Function} observer Function to observe service status update
   * @param {String} service Service name
   */
  subscribe(observer, service) {
    if (
      typeof observer === 'function' &&
      typeof service === 'string' &&
      service
    ) {
      (this.observers[service] = this.observers[service] || []).push(observer);
    }
  }

  /**
   * Remove service observer.
   *
   * @param {Function} observer Function to observe service status update
   * @param {String} service Service name
   */
  unsubscribe(observer, service) {
    if (this.observers[service]) {
      let idx = this.observers[service].indexOf(observer);
      if (idx > -1) {
        this.observers[service].slice(idx, 1);
      }
    }
  }

  /**
   * Notify all observers of the service of its current status.
   *
   * @param {String} service Service name
   * @param {Boolean} status If service is enabled
   */
  notifyAll(service, status) {
    if (this.observers[service]) {
      for (let idx in this.observers[service]) {
        this.observers[service][idx](status === true);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/util/tarteaucitron/ServicesObservable.js